export class SmsSet_Appointment {
    enable: boolean;
    daysbefore: number;
    apTime: string;
    txtmessage: string;
    attname: boolean;
    attlink: boolean;
}

export class SmsForClient {
    customerId: number;
    pelephone: string;
    txtMessage: string;
    businessEmail: string;
}